import commonSetting from '@intelligence/components/DownloadCommon/DownloadPage/configs/commonSetting';
import { getMobileDetailDownloadTitle } from '@intelligence/components/DownloadCommon/DownloadPage/common/baseSetting';
import { DownloadExcelMetricItem } from '@intelligence/components/DownloadCommon/DownloadPage/type/type';
import {
  metricTitleMap,
  mobileDetailDownloadMetricMap,
  mobileDetailDownloadSourceMetricMap,
} from '@intelligence/components/DownloadCommon/DownloadPage/common/baseConfig';
import {
  setArrayByDateMethod,
  setArrayByEditionMethod,
  setArrayByRegionMethod,
  setItem,
  setMetricTitle,
  setPercent,
  getTitleByDateType,
} from '@intelligence/components/DownloadCommon/DownloadPage/common/titleSettingAtom';
import { pipe } from '@intelligence/components/DownloadCommon/DownloadPage/utils';
const getDownloadParams = function (req: Record<string, any>): Record<string, any> {
  const {
    data_sources: sources = [],
    metric: metrics = [],
    platform: platforms = [],
    date_method,
    region_method,
    edition_method,
  } = req;
  const pipeFront = pipe(
    setArrayByDateMethod(date_method),
    setArrayByRegionMethod(region_method),
    setArrayByEditionMethod(edition_method),
  );

  const mapSourceMetrics: { [key: string]: string[] } = {};
  // let bExitLifetimeRetention = false;
  const downloadExcelMetricTitleSlice: DownloadExcelMetricItem[] = [];

  for (const source of sources) {
    const sourceMetrics = mobileDetailDownloadSourceMetricMap[source] || {};
    if (Object.keys(sourceMetrics).length === 0) continue;

    for (const metric of metrics) {
      const curMetric = mobileDetailDownloadMetricMap[metric];
      if (!curMetric || !sourceMetrics[curMetric]) continue;

      if (curMetric === 'lifetime_retention') {
        // bExitLifetimeRetention = true;
        continue;
      }

      if (!mapSourceMetrics[source]) {
        mapSourceMetrics[source] = [];
      }
      mapSourceMetrics[source].push(curMetric);

      if (curMetric === 'retention') {
        const retentionMetrics = ['D2', 'D3', 'D7', 'D15', 'D31'];
        retentionMetrics?.forEach((item) => {
          downloadExcelMetricTitleSlice.push({ Source: source, Metric: item });
        });
      } else if (source === 'stream') {
        platforms?.forEach((platform: string) => {
          downloadExcelMetricTitleSlice.push({
            Source: source,
            Metric: curMetric,
            Platform: platform,
          });
        });
      } else {
        downloadExcelMetricTitleSlice.push({ Source: source, Metric: curMetric });
      }
    }
  }

  const createDownloadTitle = (date_type: string) => {
    const pipeInLoop = pipe(setItem, setMetricTitle(metricTitleMap, date_type), setPercent);
    return getMobileDetailDownloadTitle(pipeFront, downloadExcelMetricTitleSlice, pipeInLoop);
  };

  if (req.date_type_list?.length === 1) {
    const lst = req?.date_type_list?.[0] || {};
    const downloadTitleMap = createDownloadTitle(lst);
    return {
      Stats: downloadTitleMap,
      sheetName: ['Stats'],
    };
  }
  const titleObj: Record<string, any> = {};
  const sheetNames: any[] = [];
  req.date_type_list?.forEach((date_type: string) => {
    const downloadTitleMap = createDownloadTitle(date_type);
    const sheetName = getTitleByDateType(date_type);
    sheetNames.push(sheetName);
    titleObj[sheetName] = downloadTitleMap;
  });
  return {
    ...titleObj,
    sheetName: sheetNames,
  };
};
export default (params: Record<string, any>) => {
  return {
    ...commonSetting,
    isUsingNewMethod: true,
    $$fileName: ['new_style_donwload_file_name', '_', 'start_date', '_', 'end_date'],
    downloadFetchApi: '/api/v1/intelligence_pc/download/mobile_stats_metrics',
    ...getDownloadParams(params),
  };
};
